import { render, staticRenderFns } from "./UserSocialLoginsComponent.vue?vue&type=template&id=e25895d6"
import script from "./UserSocialLoginsComponent.vue?vue&type=script&lang=js"
export * from "./UserSocialLoginsComponent.vue?vue&type=script&lang=js"
import style0 from "./UserSocialLoginsComponent.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports